import I18n from 'I18n';
import styled from 'styled-components';
import { View } from 'foundations-components/transitional/components/View';
//@ts-expect-error untyped
import * as SurveyStages from 'feedback-schema/constants/surveyStages';
//@ts-expect-error untyped
import * as BackoffTimeUnits from 'feedback-schema/constants/surveyProperties/backoffTimeUnits';
//@ts-expect-error untyped
import { handleIgnoreSurvey } from '../utils/ignoreSurvey';
//@ts-expect-error untyped
import { SURVEY_IGNORE_TIMEOUT_DAYS } from '../utils/ignoreSurvey';
//@ts-expect-error untyped
import { Selectors } from '../Constants';
import { RemoveIcon } from 'foundations-assets/icons/components/RemoveIcon';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledCloseButton = styled.span.withConfig({
  displayName: "CloseButton__StyledCloseButton"
})(["border-radius:calc(var(--trellis-space-500) / 2);font-size:calc(var(--trellis-space-500) * 0.5);line-height:var(--trellis-space-500);position:absolute;right:", ";top:", ";transition:background-color 0.15s;width:var(--trellis-space-500);height:var(--trellis-space-500);color:", ";&:hover{background-color:", ";}"], props => props.$isPopupTop ? 'calc(var(--trellis-space-500) / 2)' : 'var(--trellis-space-500)', props => props.$isPopupTop ? 'calc(var(--trellis-space-500) / 2)' : 'var(--trellis-space-500)', props => props.$closeButtonColor, props => props.$isLightText ? 'rgba(255, 255, 255, 0.2)' : 'rgba(45, 62, 80, 0.2)');
const CloseButton = ({
  stage,
  isPreview,
  isTest,
  surveyType,
  surveyId,
  portalId,
  surveyFrequencyType,
  closeButtonColor,
  onClose,
  isPopupTop = false
}) => {
  if (stage === SurveyStages.CALLOUT) {
    return null;
  }
  const isLightText = closeButtonColor === '#FFFFFF';
  const handleClick = () => {
    if (!isPreview) {
      onClose();
      if (stage === SurveyStages.QUESTION) {
        handleIgnoreSurvey({
          surveyType,
          surveyId,
          portalId,
          surveyFrequencyType,
          backoff: SURVEY_IGNORE_TIMEOUT_DAYS,
          backoffTimeUnit: BackoffTimeUnits.DAYS,
          isPreview,
          isTest
        });
      }
    }
  };
  return /*#__PURE__*/_jsx(StyledCloseButton, {
    onClick: handleClick,
    $closeButtonColor: closeButtonColor,
    $isLightText: isLightText,
    $isPopupTop: isPopupTop,
    "aria-label": I18n.text('pages.navigation.close'),
    "data-selenium-test": Selectors.CLOSE_BUTTON,
    children: /*#__PURE__*/_jsx(View, {
      paddingInlineStart: "100",
      paddingBlockStart: "50",
      children: /*#__PURE__*/_jsx(RemoveIcon, {
        size: "100"
      })
    })
  });
};
export default CloseButton;